/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetLivestockDashboardQueryResponse, GetLivestockDashboardPathParams, GetLivestockDashboardQueryParams, GetLivestockDashboard400, GetLivestockDashboard401, GetLivestockDashboard403, GetLivestockDashboard404, GetLivestockDashboard409, GetLivestockDashboard500 } from "../../types/livestockController/GetLivestockDashboard.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetLivestockDashboardUrl(organizationId: GetLivestockDashboardPathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/livestock-dashboard` as const }
  return res
}

/**
 * @summary Get livestock dashboard data
 * {@link /api/organizations/:organizationId/livestock-dashboard}
 */
export async function getLivestockDashboard(organizationId: GetLivestockDashboardPathParams["organizationId"], params?: GetLivestockDashboardQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetLivestockDashboardQueryResponse, ResponseErrorConfig<GetLivestockDashboard400 | GetLivestockDashboard401 | GetLivestockDashboard403 | GetLivestockDashboard404 | GetLivestockDashboard409 | GetLivestockDashboard500>, unknown>({ method : "GET", url : getGetLivestockDashboardUrl(organizationId).url.toString(), params, ... requestConfig })
  return res.data
}